var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,467.69c-1.33-1.14-4.29-4.75-2-8.94.83-1.54,2.61-2.3,4.22-3a17.26,17.26,0,0,0,4.63-2.4c2.51-2.14,3.2-5.68,4.87-8.53,1.91-3.27,5.48-5.72,9.25-5.55,4.32.2,7.92,3.72,9.56,7.75s1.69,8.48,1.72,12.83c0,2.4-.09,5.11-1.85,6.73s-4.08,1.51-6.28,1.45l-23.6-.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12,402.78H40l11.18,66.67a7.45,7.45,0,0,0,5.3,5.94l.22.06a4.92,4.92,0,0,0,.55.14,7.48,7.48,0,0,0,1.26.15l0,.06.3-.05H86.54a7.68,7.68,0,0,0,1.52-.15,7.48,7.48,0,0,0,6.28-6.51l5.39-45.94.24-1.83h0l2.14-18.2ZM90.41,445.31H84L84.68,426h7.38ZM92.68,426h6.1l-2.27,19.35H91Zm-18.2,40.8L74.09,450h9.17l-.55,16.81ZM64.56,450h8.91l.39,16.81h-8Zm.69,16.81H57.78c-.71-4.54-1.64-10.44-2.64-16.81h8.8Zm-1-21.45L62.7,426H72.92l.45,19.35Zm9.78,0L73.54,426H84.06l-.64,19.35Zm-.55-24L73,403.4H84.81l-.59,17.92Zm-.62,0H62.33L60.94,403.4H72.4Zm-11.09,0H50.63c-.39-2.48-.77-4.82-1.1-6.93-1.16-7.24-1.59-10-1.83-11H60.32Zm.36,4.64,1.5,19.35H54.41c-.31-2-.62-3.95-.93-5.94-.72-4.57-1.44-9.13-2.12-13.41Zm-8.29,19.35h-6L44.55,426h6.19C51.69,431.94,52.73,438.6,53.79,445.31Zm.73,4.64c.91,5.82,1.81,11.55,2.63,16.81H51.4L48.58,450Zm28.8,16.81L83.88,450H90l-1.44,16.81Zm1.51-45.44.6-17.92H94l-1.53,17.92ZM47.11,403.4c.24,1.29,1.38,8.35,2.89,17.92H43.77l-3-17.92ZM94,466.76h-4.8L90.63,450H96Zm5.33-45.44H93.07L94.6,403.4h6.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.03,
    y: 44.89,
    width: 100.1,
    height: 145.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.02,
    y: 44.89,
    width: 100.1,
    height: 145.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.45,
    y: 60.6,
    width: 75.23,
    height: 113.66,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,174.26s0-.19,0-.56,0-.91,0-1.61c0-1.43,0-3.52,0-6.23,0-5.45,0-13.39-.07-23.41,0-20-.07-48.43-.12-81.85l.25.25-75.22,0h0l.28-.27c0,42.88,0,82.41-.06,113.66l-.22-.22,54.76.12,15.13.05,4,0c.89,0,1.37,0,1.37,0s-.44,0-1.33,0l-3.93,0-15.08.05-54.89.12h-.21v-.22c0-31.25,0-70.78-.06-113.66v-.27h.28l75.22,0h.25v.25c-.05,33.49-.09,61.93-.12,82,0,10-.06,17.92-.07,23.36,0,2.69,0,4.76,0,6.18,0,.69,0,1.22,0,1.58S133.68,174.26,133.68,174.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.4,44.89a19.85,19.85,0,0,1-1.79,2.59c-1.16,1.55-2.81,3.67-4.69,6s-3.65,4.31-4.95,5.75a17.79,17.79,0,0,1-2.2,2.24,18.34,18.34,0,0,1,1.91-2.49c1.34-1.63,3-3.64,4.82-5.85l4.81-5.85A18.35,18.35,0,0,1,146.4,44.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.06,173.89a93.12,93.12,0,0,0,13.12,16.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,190.3a14.54,14.54,0,0,1-2.28-2.08,69.17,69.17,0,0,1-5-5.58,71.29,71.29,0,0,1-4.36-6.06,14.72,14.72,0,0,1-1.53-2.69,21.53,21.53,0,0,1,1.85,2.48c1.1,1.55,2.65,3.66,4.46,5.93s3.54,4.24,4.81,5.66A21.94,21.94,0,0,1,147.18,190.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,189.86l13.11-16.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11,173.68a96.11,96.11,0,0,1-6.34,8.26A99.3,99.3,0,0,1,46,189.86c-.11-.09,2.73-3.79,6.35-8.26A103.12,103.12,0,0,1,59.11,173.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,44.89a92.2,92.2,0,0,1,6.36,7.6,90.76,90.76,0,0,1,5.94,7.95A90,90,0,0,1,52,52.83,90.82,90.82,0,0,1,46,44.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.05,
    y: 83.68,
    width: 25.19,
    height: 71.52,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.38,
    y: 35.17,
    width: 94.49,
    height: 98.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.98,
    y: 35.17,
    width: 94.49,
    height: 98.5,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5,133.7H354V35.14H448.5ZM354,133.64h94.43V35.2H354Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.68,
    y: 48.41,
    width: 69.09,
    height: 72.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.68,120.91a11.45,11.45,0,0,1-1.7,2c-1.11,1.16-2.66,2.74-4.39,4.45s-3.34,3.24-4.52,4.32a11,11,0,0,1-2,1.66,11.8,11.8,0,0,1,1.7-2c1.1-1.16,2.66-2.74,4.4-4.46s3.35-3.25,4.52-4.33A10.69,10.69,0,0,1,366.68,120.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.77,120.73a11,11,0,0,1,2,1.7c1.17,1.11,2.74,2.66,4.45,4.4s3.24,3.33,4.33,4.51a11,11,0,0,1,1.66,2,11.45,11.45,0,0,1-2-1.7c-1.16-1.1-2.74-2.66-4.46-4.4s-3.24-3.35-4.33-4.52A11.23,11.23,0,0,1,435.77,120.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,48.6a11.42,11.42,0,0,1,1.71-2c1.1-1.17,2.65-2.74,4.39-4.45s3.33-3.24,4.51-4.32a10.87,10.87,0,0,1,2-1.67,10.91,10.91,0,0,1-1.7,2c-1.1,1.16-2.66,2.74-4.4,4.46s-3.34,3.24-4.52,4.33A10.82,10.82,0,0,1,435.58,48.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.49,48.78a11.42,11.42,0,0,1-2-1.71c-1.16-1.1-2.74-2.65-4.45-4.39s-3.24-3.34-4.32-4.51a10.87,10.87,0,0,1-1.67-2,10.91,10.91,0,0,1,2,1.7c1.16,1.1,2.74,2.65,4.46,4.4s3.24,3.34,4.33,4.52A10.32,10.32,0,0,1,366.49,48.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,120.43s0-.13,0-.35,0-.58,0-1c0-.9,0-2.2,0-3.89,0-3.41,0-8.37-.07-14.67,0-12.62-.08-30.59-.14-52.1l.27.26-68.89,0h0l.31-.3c0,26.43,0,51.16-.05,72l-.26-.27,49.89.14,14,.07,3.71,0h1a2.22,2.22,0,0,1,.33,0h-.3l-.93,0-3.66,0-13.95.07-50.06.13h-.26v-.26c0-20.86,0-45.59,0-72V48.1h.31l68.89,0h.27v.27c-.06,21.58-.11,39.61-.14,52.27,0,6.27,0,11.22-.07,14.61q0,2.5,0,3.84c0,.42,0,.74,0,1A2,2,0,0,1,435.58,120.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.7,
    y: 72.89,
    width: 23.05,
    height: 23.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.37 444.18 304.37 474.29 348.4 474.29 396.97 474.29 396.97 444.18 304.37 444.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.48 435.76 300.48 444.18 400.2 444.18 400.2 435.76 348.4 435.76 300.48 435.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.34 474.29 396.97 474.29 396.97 444.18 400.2 444.18 400.2 435.76 348.4 435.76 348.4 443.4 350.34 474.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.32,
    y: 449.03,
    width: 18.78,
    height: 4.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.9,
    y: 459.23,
    width: 24.11,
    height: 9.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.61 405.69 318.61 435.8 362.65 435.8 411.21 435.8 411.21 405.69 318.61 405.69",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.17 397.27 315.17 405.69 414.9 405.69 414.9 397.27 363.09 397.27 315.17 397.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.59 435.8 411.66 435.8 411.66 405.69 414.45 405.69 414.45 397.27 362.65 397.27 362.65 404.91 364.59 435.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.56,
    y: 410.54,
    width: 18.78,
    height: 4.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.15,
    y: 420.74,
    width: 24.11,
    height: 9.57,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.21,475.28c0,.14-104.87.26-234.2.26s-234.22-.12-234.22-.26S118.64,475,248,475,482.21,475.13,482.21,475.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-2--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.74,224.39v1h-4v-.79l2.3-2.72h-2.24v-1h3.89v.79l-2.3,2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.41,220v2.36H229v-1.85l5.38-6.36h-5.24v-2.36h9.11v1.85L232.85,220Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.93,214.59v4.75h-19v-3.72l10.85-12.83H206.21V198h18.36v3.72l-10.84,12.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220,157.14H205.49v18.67h-26.9V157.14H127v-18l43.76-60.91h28.58l-39.73,57h19.8V118.67h26.06v16.59H220Z",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,127c0-32.19,18.12-50.73,43.07-50.73S311.55,94.84,311.55,127s-18.12,50.73-42.93,50.73S225.55,159.23,225.55,127Zm58.26,0c0-20.49-6.41-28.15-15.19-28.15s-15.33,7.66-15.33,28.15,6.41,28.16,15.33,28.16S283.81,147.52,283.81,127Z",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,157.14h-14.5v18.67h-26.9V157.14H320v-18l43.77-60.91h28.57l-39.72,57h19.79V118.67h26.06v16.59H413Z",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220,157.14H205.49v18.67h-26.9V157.14H127v-18l43.76-60.91h28.58l-39.73,57h19.8V118.67h26.06v16.59H220Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.55,127c0-32.19,18.12-50.73,43.07-50.73S311.55,94.84,311.55,127s-18.12,50.73-42.93,50.73S225.55,159.23,225.55,127Zm58.26,0c0-20.49-6.41-28.15-15.19-28.15s-15.33,7.66-15.33,28.15,6.41,28.16,15.33,28.16S283.81,147.52,283.81,127Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M413,157.14h-14.5v18.67h-26.9V157.14H320v-18l43.77-60.91h28.57l-39.72,57h19.79V118.67h26.06v16.59H413Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M211.91,157.14h-14.5v18.67h-26.9V157.14H118.94v-18l43.77-60.91h28.57l-39.72,57h19.79V118.67h26.06v16.59h14.5Z",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,127c0-32.19,18.12-50.73,43.07-50.73S303.47,94.84,303.47,127s-18.12,50.73-42.93,50.73S217.47,159.23,217.47,127Zm58.26,0c0-20.49-6.41-28.15-15.19-28.15s-15.33,7.66-15.33,28.15,6.41,28.16,15.33,28.16S275.73,147.52,275.73,127Z",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93,157.14h-14.5v18.67h-26.9V157.14H312v-18l43.77-60.91H384.3l-39.72,57h19.79V118.67h26.06v16.59h14.5Z",
    style: {
      fill: "#325EC2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-1--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.79,54.18c0-5.77,4.53-10,10.67-10s10.68,4.22,10.68,10-4.53,10-10.68,10S228.79,59.94,228.79,54.18Zm15.86,0a5.19,5.19,0,1,0-10.37,0,5.19,5.19,0,1,0,10.37,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.81,56.32c0-4.48,3.54-7.66,8.4-7.66s8.39,3.18,8.39,7.66-3.48,7.7-8.39,7.7S251.81,60.81,251.81,56.32Zm11.52,0c0-2.25-1.34-3.52-3.12-3.52s-3.13,1.27-3.13,3.52,1.37,3.56,3.13,3.56S263.33,58.59,263.33,56.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.67,56.34c0,4.72-3.26,7.68-7.3,7.68a5.55,5.55,0,0,1-4.14-1.56V69.1H271V48.91h5v1.48a5.38,5.38,0,0,1,4.39-1.73C284.41,48.66,287.67,51.62,287.67,56.34Zm-5.27,0c0-2.25-1.37-3.54-3.12-3.54s-3.13,1.29-3.13,3.54,1.37,3.54,3.13,3.54S282.4,58.59,282.4,56.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91,62.49l1.56-3.57a10.45,10.45,0,0,0,5.19,1.37c1.75,0,2.33-.38,2.33-1,0-2-8.78.27-8.78-5.68,0-2.8,2.58-4.94,7.24-4.94a13.06,13.06,0,0,1,5.87,1.26l-1.56,3.54a8.74,8.74,0,0,0-4.28-1.1c-1.76,0-2.39.5-2.39,1,0,2.05,8.75-.17,8.75,5.73,0,2.74-2.52,4.88-7.35,4.88A13.69,13.69,0,0,1,288.91,62.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.44,61.14a3.13,3.13,0,0,1,6.23,0,3.12,3.12,0,0,1-6.23,0Zm0-16.57h6.2l-1.05,12.21h-4.14Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.16,
    y: 383.35,
    width: 12.34,
    height: 59.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.19,375.72c.2,0,38,11.85,38,11.85h12.33l43.29-11.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,176.93c-5.47,1.23-10.36,6.28-9.54,16.36,0,0-4.36.82-4.09,8.73s-.54,57,9.27,83.7c8.07,21.95,22,68.9,26.74,84.93a7.66,7.66,0,0,0,7.35,5.49H188.15a14,14,0,0,0,13.94-14.54h0A14,14,0,0,0,188,348.23l-77.82.81s-4.77-25.7-9.68-26c0,0,2.18-16.09-6-20.72,0,0,1.63-19.86-7.09-21.65,0,0,1.36-16.62-6-19.57,0,0,4.09-14.95-3.54-22.58,0,0,2.18-17.45,0-30.54S74.89,171.76,51.7,176.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.62,363.22s-.18,0-.54,0l-1.58,0-6.13.05-22.85.07-78.19.09h-.18l-.06-.17-11-31.9c-6.39-18.69-12.44-36.51-17.77-52.77-1.33-4.07-2.61-8-3.81-11.92a53.42,53.42,0,0,1-1.54-5.8,26.86,26.86,0,0,1-.46-2.9c-.11-1-.28-1.92-.34-2.87-.69-7.59-.85-14.69-1-21.16-.17-12.94,0-23.42.18-30.65.1-3.61.18-6.41.23-8.33l.09-2.17c0-.49.05-.73.05-.73s0,.25,0,.73,0,1.23,0,2.17c0,1.92-.08,4.73-.14,8.33-.1,7.24-.23,17.71,0,30.65.14,6.46.32,13.55,1,21.12.07,1,.23,1.89.34,2.85a26,26,0,0,0,.47,2.87A52.31,52.31,0,0,0,52,266.58c1.2,3.87,2.49,7.83,3.83,11.9,5.35,16.25,11.42,34.06,17.8,52.75,3.8,11,7.48,21.78,11,31.91l-.24-.17,78.19.09,22.85.07,6.13,0,1.58,0C193.44,363.2,193.62,363.22,193.62,363.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.57,349.16a6.57,6.57,0,0,1-1,.87c-.67.53-1.62,1.33-2.76,2.33a76.9,76.9,0,0,0-8.28,8.52,80.91,80.91,0,0,0-6.9,9.67c-.79,1.3-1.41,2.37-1.82,3.12a6.62,6.62,0,0,1-.7,1.13,6.44,6.44,0,0,1,.52-1.22c.36-.78.93-1.88,1.68-3.21a68.17,68.17,0,0,1,6.82-9.83,65,65,0,0,1,8.44-8.46c1.18-1,2.17-1.73,2.87-2.21A6.23,6.23,0,0,1,98.57,349.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.18,349s-.26,0-.77,0l-2.24.06-8.6.14h-.11v-.11l-.18-1.06a8.18,8.18,0,0,0-.39-1,3,3,0,0,0-1.71-1.49,7.14,7.14,0,0,0-5.1.81l-.36.17.13-.37a19.56,19.56,0,0,0,.5-10.95,19.78,19.78,0,0,0-6.78-10.87l-.13-.1.06-.15A16.37,16.37,0,0,0,80,306.47l-.13-.1.06-.16a20.78,20.78,0,0,0-8-23.19l-.12-.08v-.14a68.39,68.39,0,0,0-.26-8.27,42.25,42.25,0,0,0-1.55-8.3c-.82-2.62-2.06-5.24-4.25-6.76l-.16-.11.06-.18A36.29,36.29,0,0,0,67,246.8,22.14,22.14,0,0,0,65.74,241a16,16,0,0,0-3-4.89l-.12-.14.09-.15a22.65,22.65,0,0,0,3.48-11.61,16.89,16.89,0,0,0-3.44-10.29l0-.06v-.07a32.78,32.78,0,0,0-2.91-14.34,14.1,14.1,0,0,0-3.68-4.73,11.15,11.15,0,0,0-4.53-2.19,14.28,14.28,0,0,0-4.06-.28l-1.63.18-1.34.27c-.8.15-1.39.37-1.79.46s-.62.15-.62.15a24,24,0,0,1,2.38-.72l1.34-.3,1.65-.21a14.14,14.14,0,0,1,4.11.24,11.17,11.17,0,0,1,4.66,2.19,14.28,14.28,0,0,1,3.79,4.8,32.93,32.93,0,0,1,3,14.49l0-.12a17.26,17.26,0,0,1,3.56,10.53,23.12,23.12,0,0,1-3.52,11.87l0-.29a16.65,16.65,0,0,1,3.11,5,22.49,22.49,0,0,1,1.3,6,36.47,36.47,0,0,1-1.35,12.58L66,259c2.37,1.65,3.62,4.37,4.46,7a41.4,41.4,0,0,1,1.58,8.4,67.47,67.47,0,0,1,.25,8.34l-.11-.23a21.27,21.27,0,0,1,8.21,23.78l-.07-.27a16.79,16.79,0,0,1,4.54,18.18l-.07-.25a20,20,0,0,1,6.88,11.12,19.78,19.78,0,0,1-.57,11.15l-.22-.2a10.52,10.52,0,0,1,2.69-.9,5.19,5.19,0,0,1,2.66.11A3.25,3.25,0,0,1,98.11,347a8.11,8.11,0,0,1,.4,1.1l.18,1.1-.12-.11,8.6,0h2.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9,302l-35.69,4.6a7.09,7.09,0,0,0,5.2,3.53A22.43,22.43,0,0,0,71.9,310a193,193,0,0,1,27.83-1A40.09,40.09,0,0,0,95.9,302Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M78.26,236.59a51.5,51.5,0,0,1-7.42.43,55.61,55.61,0,0,1-7.43-.1,51.5,51.5,0,0,1,7.42-.43A55.53,55.53,0,0,1,78.26,236.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,466s5.71-17.42,13.58-21.64c12.64-6.77,41.79-10,41.79-10l3.19,8.24s-38.87,1.53-45,9.37a163.15,163.15,0,0,0-9.76,14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.91,
    cy: 467,
    r: 8.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,465.69s-5.71-17.42-13.58-21.64c-12.64-6.77-41.78-10-41.78-10l-3.2,8.24s38.87,1.53,45,9.38a162.16,162.16,0,0,1,9.76,14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.37,
    cy: 467,
    r: 8.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "126.07 438.8 127.88 461.22 132.98 462.23 132.98 438.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.32,
    cy: 467,
    r: 8.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,263.24a38.38,38.38,0,0,1,6.08-1.52,37.85,37.85,0,0,1,6.19-1,38,38,0,0,1-6.08,1.52A38.19,38.19,0,0,1,69,263.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.68,280.69a8.33,8.33,0,0,1-2.05.66c-1.29.33-3.08.71-5.08,1s-3.82.5-5.14.58a8.1,8.1,0,0,1-2.15,0c0-.15,3.24-.46,7.21-1.09S86.64,280.55,86.68,280.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,323.91a9.93,9.93,0,0,1-2.38.36c-1.48.15-3.53.28-5.8.35s-4.32,0-5.81,0a9.93,9.93,0,0,1-2.39-.23,12.08,12.08,0,0,1,2.4-.14l5.79-.13,5.78-.2A12.08,12.08,0,0,1,101.42,323.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.57,339.57c0,.16-3.32.88-7.19,2.53s-6.73,3.53-6.82,3.4a7.53,7.53,0,0,1,1.8-1.36,33.12,33.12,0,0,1,4.82-2.52,32.19,32.19,0,0,1,5.16-1.7A8.6,8.6,0,0,1,105.57,339.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,376.33c0,.14-19.67.22-43.93.16s-43.94-.2-43.94-.35,19.67-.22,43.94-.17S172.29,376.18,172.29,376.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,388a32.65,32.65,0,0,1-5.87.26,32.72,32.72,0,0,1-5.88-.26,33.87,33.87,0,0,1,5.88-.26A33.8,33.8,0,0,1,135.88,388Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,435.78a12.7,12.7,0,0,1-11.88.31,26,26,0,0,0,6,.8A26,26,0,0,0,136.44,435.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.92,250.53s-4.7-7.21-7.42-9.67c-2.1-1.89-12.29-5.64-16.87-7.27a14,14,0,0,0-4.57-.8c-6-.06-21.86,0-29.94,1.44-10.07,1.84,56.74,54.38,56.74,54.38l55.65.13L315.15,275,278,267.33l-20.5-16.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5,236.13s3.68.18,8.81,1,10.76,1.08,13.58,3.58c1.89,1.67,13.45,2,13.45,2l-16-.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M209.22,234.81a3.79,3.79,0,0,1,1,.12c.65.12,1.6.31,2.75.6,2.31.57,5.47,1.45,8.94,2.49l3.83,1.19h-.06a41,41,0,0,1,7.74,1.09h0l0,0a5.29,5.29,0,0,1,.48,1.24,6.13,6.13,0,0,1-.68-1.14l.06.06a62.67,62.67,0,0,0-7.69-.81h-.06l-3.84-1.16-8.88-2.63-2.7-.77A3.78,3.78,0,0,1,209.22,234.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,288.22c.08-.42-1.1-5.21-1.22-5.69s-3.78-6-3.78-6l-2-.61s-9.3-2.21-11.18-2.08l-1.31.14s-2.44.18-3.4.35-6.91,2.26-6.91,2.26a16.61,16.61,0,0,1-4.44.33,59.11,59.11,0,0,1-6.09-1.32l-2.38,13.1,4.5-.14a22.66,22.66,0,0,0,4.33,1.07c1.62.11,6.21.61,6.21.61s7.09,3,8.87-1.18-5.06-4.61-5.06-4.61l2.12-1.5,5.43-.56,1.41.45,1.55,2.4s-.42,5.3,3,4.94l.9-.1.48-5.44-1.62-5.5,3.58,5.43s.31,4.7,1.86,5.31a.81.81,0,0,0,.38.07c1.88-.06,2.25-.59,2.25-.59l.39-.95S354.33,289.65,354.6,288.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27,274a4.6,4.6,0,0,1,1.7.07,16.34,16.34,0,0,1,4,1.07,8.31,8.31,0,0,1,3.37,2.4,2.88,2.88,0,0,1,.74,1.55c-.09,0-.34-.57-1-1.31a9.34,9.34,0,0,0-3.3-2.16C336.84,274.45,334.24,274.19,334.27,274Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,279.72c.14,0,.24.57.31,1.25s.09,1.26-.05,1.3-.39-.52-.47-1.24S337.62,279.71,337.77,279.72Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27,279.9c.11-.1,1.1,1,2.68,1.76s3,1,3,1.12a4.94,4.94,0,0,1-3.25-.66A4.82,4.82,0,0,1,334.27,279.9Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,280.39a2.92,2.92,0,0,1,1.4.5A7.83,7.83,0,0,1,327,283.3a9.11,9.11,0,0,1,.58,1l-.27-.14a7,7,0,0,1,3.89.33,32,32,0,0,0-3.81.17l-.18,0-.09-.16a9,9,0,0,0-.55-.93A12.83,12.83,0,0,0,322.93,280.39Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,275.87a6.09,6.09,0,0,1,1.35,1.51,18.33,18.33,0,0,1,2.3,4.32,17.84,17.84,0,0,1,1.07,4.78,5.84,5.84,0,0,1,0,2,37.91,37.91,0,0,0-1.52-6.62A38.24,38.24,0,0,0,347.8,275.87Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.22,432.78l-1,27.06S285.35,470,285.65,475l-52.54-.11L233,432.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,457.53a2.13,2.13,0,0,0-1.48,2.44,2.05,2.05,0,0,0,2.41,1.5,2.26,2.26,0,0,0,1.56-2.6,2.15,2.15,0,0,0-2.68-1.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,474.88l.16-4.26,50.31,1.7s2.33,1,2.07,2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,459.57c0,.26-1.3.37-2.56,1.19s-1.94,1.9-2.18,1.8.15-1.58,1.7-2.55S259.1,459.34,259.05,459.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.55,461.86c.06.25-1.05.68-1.93,1.77s-1.12,2.23-1.38,2.22-.42-1.47.7-2.79S264.55,461.62,264.55,461.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.67,468.46c-.24.06-.59-1.22.07-2.63s1.86-2,2-1.74-.64,1-1.16,2.12S267.92,468.44,267.67,468.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,453.38c-.11.23-1.29-.12-2.74,0s-2.58.55-2.71.33.95-1.13,2.66-1.22S258.72,453.18,258.6,453.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.11,430l-17,21S215.73,475.4,213,479.6L171,448l25.21-33.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,439.42a2.16,2.16,0,0,0-2.66,1.07,2.06,2.06,0,0,0,1,2.64,2.27,2.27,0,0,0,2.81-1.14,2.14,2.14,0,0,0-1.38-2.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,448l2.67-3.31,39.25,31.52s1.26,2.22.06,3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,451.31c-.16.2-1.26-.48-2.76-.58s-2.69.36-2.82.13,1.07-1.17,2.89-1S201.1,451.15,200.91,451.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.94,456.44c-.1.24-1.25-.08-2.6.26s-2.24,1.11-2.44.95.55-1.42,2.23-1.82S204.09,456.24,203.94,456.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,463.59c-.22-.09.26-1.33,1.64-2.06s2.66-.45,2.62-.21-1.09.38-2.2,1S202.7,463.73,202.48,463.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,446.08c-.22.12-.95-.87-2.17-1.66s-2.4-1.11-2.37-1.36,1.44-.34,2.87.62S204.48,446,204.26,446.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,243.27a91.29,91.29,0,0,1,15.54-2.73,32,32,0,0,1,15.44,2.52c.72.33,5.54,3.11,5.39,3.89-.1.56-4.65-1.27-5.16-1-4.92,2.35-10.62,2.64-16,1.76a71.57,71.57,0,0,1-15.21-4.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,241.27l47.26,3.11c13.2.65,23.82,8.86,22.81,22l-.16,1.21a23.63,23.63,0,0,1-24.68,20.42c-11.44-.63-24.07-1.46-30.12-2.36C231.88,283.83,231.64,271,231.64,271s-1.12-.14-4.82-.48l-12-8.65h0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.64,271a30.54,30.54,0,0,1,7.05-15.7s-10,2.66-10.55,15.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.65,276.64c.26.2-.58,1.69-.33,3.62s1.4,3.22,1.19,3.46-.54-.05-1.07-.61a5,5,0,0,1-1.24-2.74,4.76,4.76,0,0,1,.55-2.92C265.13,276.8,265.53,276.55,265.65,276.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,259.38c.23.23-.8,1.59-.83,3.54s.93,3.39.68,3.59c-.1.11-.52-.13-1-.76a5,5,0,0,1-.84-2.88,4.77,4.77,0,0,1,1-2.81C266.52,259.47,267,259.27,267.05,259.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.71,270.55a13.27,13.27,0,0,1,.14,3.21c0,.5,0,1,.34,1.11a2.51,2.51,0,0,0,1.51-.13l3.95-.95c5.62-1.3,10.21-2.17,10.26-1.94s-4.46,1.46-10.08,2.76l-4,.89a2.9,2.9,0,0,1-2,0,1.24,1.24,0,0,1-.61-.91,3.43,3.43,0,0,1,0-.85A12.6,12.6,0,0,1,255.71,270.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,267.08c-.45-.33.32-2.13.68-4.41s.26-4.22.8-4.38c.25-.07.65.38.94,1.23a7.74,7.74,0,0,1-1.13,6.7C278.17,266.94,277.65,267.23,277.43,267.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,285.48c-.39-.46.26-2,.51-3.87s.12-3.53.63-3.84c.24-.14.65.17,1,.92a6.14,6.14,0,0,1,.34,3.23,6,6,0,0,1-1.25,3C275.7,285.52,275.22,285.68,275,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,244.15c.12-.2,3.72-8.29-4.9-9.18s-7.74,8-7.5,8S267.14,244.15,267.14,244.15Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,240.67s-.09-.16-.18-.43a1.52,1.52,0,0,1,.1-1.12c.43-.88,1.95-1.5,3.51-1.38a5,5,0,0,1,2.11.64,1.77,1.77,0,0,1,1,1.25.78.78,0,0,1-.51.85c-.25.09-.42,0-.44.06s.13.2.49.17a1,1,0,0,0,.58-.29,1.14,1.14,0,0,0,.3-.81,2.1,2.1,0,0,0-1.17-1.7,5,5,0,0,0-2.35-.77c-1.75-.13-3.47.59-3.95,1.8a1.62,1.62,0,0,0,.08,1.4C258.08,240.63,258.27,240.7,258.28,240.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,283.81c.64,1.47,5.56-2.3,7.45-5.58,2.84-5,5-12.76,4.13-17.67-1.09-5.92-3.5-11-8.47-14.36a34.12,34.12,0,0,0-17-5.45,10.36,10.36,0,0,0-5.39.72c-2,1-3.44,3.23-6.07,2.88a3.6,3.6,0,0,0-2.72.65c-1.83,1.42-.43,3.5,1.07,4.54,3.2,2.21,7.22,2.81,11.08,3.34a25.48,25.48,0,0,0,8.26.23c1.48-.29,2.9-.84,4.39-1a5.21,5.21,0,0,1,4.26,1,5.88,5.88,0,0,1,.64.77,9.05,9.05,0,0,1,.86,9.09c-2.18,4.7-5.53,12.76-4.09,15.09,2.08,3.34,3.56,4.23,3.56,4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.29,239.94a5.51,5.51,0,0,0-3.84-4.41c0-.07.39-.11,1,.05a4.11,4.11,0,0,1,2,1.26,4.17,4.17,0,0,1,1,2.13C267.45,239.57,267.36,239.94,267.29,239.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.48,266.07a2,2,0,0,0-2.42-1.13l.25-.11a1.93,1.93,0,0,0-2.08,1.27,2.26,2.26,0,0,0,.72,2.39,2.36,2.36,0,0,0,2.73.17A2.19,2.19,0,0,0,251.48,266.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,268.3a1.9,1.9,0,0,0,.45-1.22,2.49,2.49,0,0,0-.27-1.35,2.17,2.17,0,0,0-1.49-.66,2.35,2.35,0,0,0-1.62.34,1.66,1.66,0,0,0-.75,1.1,2.22,2.22,0,0,0,.27,1.27s-.16,0-.33-.24a1.66,1.66,0,0,1-.31-1.07,2,2,0,0,1,.84-1.45,2.73,2.73,0,0,1,2-.47,2.46,2.46,0,0,1,1.82.92,2.51,2.51,0,0,1,.24,1.64,1.7,1.7,0,0,1-.44,1C251.14,268.31,251,268.33,251,268.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.94,258.25a23.09,23.09,0,0,0-20.36-16.2l-3.48-.16a4,4,0,0,0-1.8.17,1.37,1.37,0,0,0-.9,1.43c.15.68.9,1,1.57,1.18,4,1.07,8.2.87,12.07,2.23a15.6,15.6,0,0,1,9.9,18.72,4.65,4.65,0,0,0-.26,1.76,1.34,1.34,0,0,0,1.1,1.24,1.72,1.72,0,0,0,1.35-.85C301.12,265.12,300.92,261.41,299.94,258.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,266.71c0,.06-.45.07-1.08-.22a3.8,3.8,0,0,1-2-4.58c.22-.66.53-1,.58-.94s-.11.41-.22,1a4,4,0,0,0,1.82,4.17C264.57,266.51,265,266.63,264.94,266.71Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45,283.14a4.23,4.23,0,0,1,.9-5.07c.13.1-.56,1.07-.8,2.48S262.6,283.1,262.45,283.14Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,316.31c.6-.22,43,1.85,56.76,3.06s37.61,7.7,38.79,23.9c1,13,.77,103.6.77,103.6h-37l-.88-95.75-57.47-14.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.39,322.41s20.6,3.72,37.05,8.39,23.71,14.66,26.11,20.61,3.54,14.84-1.51,23.18c-3.19,5.28-19.18,23.86-19.18,23.86s-3.3-53.32-3.46-54.13S201.39,322.41,201.39,322.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M262.74,357.47C261,347.19,249.36,340,235.09,334.65c-14.06-5.29-50.85-18.36-50.85-18.36l-8.81-2.17h-3.94l-1.3-3.9s-25-7.23-61.11,6.09l-1.23,1s-1.09,26.34,4,32c0,0,57.52-.81,60.54-.56s45.2,19.39,45.2,19.39l-36.11,55.39,29.86,20.86s18-25.66,29-41C256.05,381.37,264.8,369.61,262.74,357.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.74,357.47s.09.62.24,1.83a22,22,0,0,1-.2,5.37,32.78,32.78,0,0,1-2.63,8.31,83.21,83.21,0,0,1-5.75,10.36c-4.78,7.53-11.26,16.25-18.45,26.53l-24.44,34.64-.12.17-.17-.12-29.87-20.84-.18-.13.12-.19c11.05-16.95,23.24-35.68,36.09-55.4l.1.37q-12-5.44-24.62-11c-4.2-1.83-8.43-3.67-12.72-5.46-2.15-.87-4.3-1.79-6.5-2.55a6.7,6.7,0,0,0-.81-.24A2.26,2.26,0,0,0,172,349c-.57,0-1.16,0-1.74,0h-3.53c-18.85.1-37.23.36-54.87.59h-.12l-.08-.08a11,11,0,0,1-1.92-3.8,31.21,31.21,0,0,1-1-4.07,77,77,0,0,1-1-8.19c-.35-5.45-.38-10.81-.21-16.09v-.11l.09-.07,1.23-1,0,0,0,0a132.53,132.53,0,0,1,31.64-7.44,103.14,103.14,0,0,1,15.24-.5A71.61,71.61,0,0,1,170.25,310l.11,0,0,.11c.45,1.37.87,2.65,1.29,3.91l-.2-.14h4l8.82,2.18h0l35.76,12.95,14.7,5.33a96.53,96.53,0,0,1,12,5.38c7,3.72,11.66,8.09,13.73,11.76a21.28,21.28,0,0,1,1.24,2.46,18.91,18.91,0,0,1,.63,1.9c.24,1.05.34,1.58.34,1.58s-.14-.53-.39-1.57c-.12-.52-.4-1.13-.66-1.87-.13-.38-.36-.75-.55-1.16a9.68,9.68,0,0,0-.71-1.28c-2.09-3.63-6.75-7.94-13.74-11.63a96.43,96.43,0,0,0-12-5.31L220,329.36l-35.78-12.88h0l-8.81-2.17h-4l0-.14L170,310.28l.15.14a71.15,71.15,0,0,0-14.28-1.84,102.21,102.21,0,0,0-15.17.52,132.09,132.09,0,0,0-31.52,7.44l.07,0-1.23,1,.09-.18c-.17,5.25-.13,10.62.22,16a77.74,77.74,0,0,0,.94,8.14,34.23,34.23,0,0,0,1,4,10.64,10.64,0,0,0,1.82,3.62l-.19-.09c17.65-.23,36-.5,54.88-.6h3.53c.59,0,1.18,0,1.77,0a2.82,2.82,0,0,1,.9.14,6,6,0,0,1,.88.26c2.23.77,4.37,1.68,6.53,2.56,4.29,1.79,8.53,3.63,12.72,5.47q12.58,5.52,24.63,11l.27.12-.16.25-36.12,55.38-.06-.32,29.84,20.88-.29,0,24.51-34.6c7.21-10.26,13.72-19,18.52-26.45A83.68,83.68,0,0,0,260,372.9a33,33,0,0,0,2.67-8.25,23.09,23.09,0,0,0,.26-5.35C262.79,358.1,262.74,357.47,262.74,357.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.51,361.39a27,27,0,0,1-2.86.51A35.3,35.3,0,0,0,219.79,367c-1.5,1-2.38,1.64-2.44,1.58a10.74,10.74,0,0,1,2.23-1.88,28.77,28.77,0,0,1,6.2-3.35,29.4,29.4,0,0,1,6.82-1.77A12.15,12.15,0,0,1,235.51,361.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.02 270.37 229.02 273.54 221.29 274.26 220.85 272.64 222.93 267.81 229.02 270.37",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.98 272.87 213 292.85 215.21 328.71 210.2 336.53 204.93 327.51 205.84 293.39 221.38 271.4 222.98 272.87",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,239.53s-14.08-5.34-27.69-6.23-30.44,8.24-38.48,11.81-38.78,34-45.43,44.12c-3.81,5.82-8.89,19-8.89,19-.86,4.6,2.35,9.08,2.35,9.08l61.89.46h11.61l4.91-10.49s9.37-.67,12.05-5.8,12.5-12.72,12.5-12.72L222,270.26l7.36,1.56,4.08-31.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,253.6a4.87,4.87,0,0,1-.28,1.08c-.23.8-.52,1.76-.87,2.9a95.4,95.4,0,0,0-2.26,9.69,92,92,0,0,0-1.17,9.89c-.06,1.18-.12,2.19-.16,3a5.23,5.23,0,0,1-.11,1.11,4.29,4.29,0,0,1-.1-1.11c0-.71,0-1.75,0-3a69.8,69.8,0,0,1,1-10,71.94,71.94,0,0,1,2.42-9.71c.4-1.22.76-2.19,1-2.85A4.88,4.88,0,0,1,180.12,253.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,376.91s4.24,4.94,5.55,6.73c1.18,1.6,2.35,7.46,2.8,13.18a2.06,2.06,0,0,1-2.69,2.15,1.73,1.73,0,0,1-1.09-1.34c-.91-4.14-1.15-5.9-1.15-5.9-.12-2-.33-1.72-.39-.37s1,8.82,1,8.82,2.86,10.19,2.09,11.33a1.86,1.86,0,0,1-2.91.13c-.39-.53-3.61-9-3.61-9L206,398s1.66,14.66.73,15.81a1.59,1.59,0,0,1-2.57.12c-.65-.58-1.31-7.06-1.31-7.06l-1.51-8.65.27,16.49s-.17,1.56-1.4,1.62-2-1.75-2-1.75l-1.77-17s.57,9.45-.07,9.95c-.85.66-1.62.44-1.9-.29-.57-1.47-1.4-10-1.4-10l-.78-16.18-.57-5.35,14.16-5.07Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.57,275.86a226.86,226.86,0,0,0-9.26,41.83A95.48,95.48,0,0,0,169.07,333c1.63,8.09,14.9,43.17,14.9,43.17l9.09.79-7.66-62.32,7.66-29.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M217.32,249.29c6.23,1.92,7.4,14.55,6.06,18.15-4.29,11.55-18,22.4-17.8,21.77l-8.91,35.44,12.63,48-20.42,7.31s-18.63-49.28-19-57,5.18-27.84,6-39.87c.53-7.73,4.45-23.41,14-32.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.89,250.38s-.15.18-.46.52-.79.83-1.38,1.51a44,44,0,0,0-4.48,6.43,59,59,0,0,0-4.9,11.43,61.37,61.37,0,0,0-1.89,7.56c-.24,1.36-.46,2.76-.59,4.21s-.22,3-.43,4.49c-.72,6.12-2.06,12.75-3.41,19.89-.66,3.56-1.36,7.26-1.86,11.09a29.18,29.18,0,0,0-.27,5.84l.21,1.46.34,1.46c.21,1,.49,2,.77,3,1.09,3.94,2.39,7.94,3.75,12s2.8,8.23,4.29,12.46c3,8.45,6.18,17.19,9.54,26.13l-.33-.15,9.49-3.4,10.93-3.91-.16.31c-4.49-17.07-8.74-33.25-12.61-48v-.12c3.31-13.08,6.32-25,8.95-35.43l.37.1a.17.17,0,0,0-.18-.22h0l.06,0,.14-.08.28-.19.56-.42,1.08-.87c.7-.6,1.38-1.2,2-1.81,1.32-1.21,2.56-2.45,3.72-3.69a60.08,60.08,0,0,0,6-7.46,32.7,32.7,0,0,0,3.85-7.38,18.65,18.65,0,0,0,.18-6.95c-.56-4.19-1.94-7.31-3.44-9a7.44,7.44,0,0,0-2.76-1.92s.28.1.81.32a3.76,3.76,0,0,1,.92.55,5.65,5.65,0,0,1,1.11,1c1.55,1.64,3,4.78,3.57,9a25.31,25.31,0,0,1,.26,3.36,13.7,13.7,0,0,1-.4,3.7,32.41,32.41,0,0,1-3.85,7.47,60.43,60.43,0,0,1-6,7.53c-1.17,1.25-2.41,2.5-3.73,3.72-.66.62-1.34,1.23-2,1.83-.35.29-.71.59-1.08.88l-.57.43-.3.2-.16.1-.1,0-.09,0a.22.22,0,0,1-.24-.27l.38.1-8.87,35.45v-.12l12.65,48,.06.23-.22.08-10.93,3.91-9.5,3.4-.24.09-.09-.24c-3.36-8.95-6.54-17.7-9.53-26.15-1.48-4.23-2.93-8.39-4.28-12.47s-2.64-8.1-3.74-12.06c-.28-1-.55-2-.76-3-.12-.5-.23-1-.34-1.48s-.15-1-.22-1.52a29.06,29.06,0,0,1,.29-5.92c.51-3.86,1.21-7.55,1.89-11.12,1.37-7.14,2.73-13.75,3.47-19.86.21-1.52.29-3,.44-4.47s.37-2.88.62-4.24a61.1,61.1,0,0,1,1.93-7.58,57.38,57.38,0,0,1,5-11.44,40.84,40.84,0,0,1,4.57-6.41C189.2,251,189.89,250.38,189.89,250.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,257.49a11.59,11.59,0,0,1,0-2.66,62.41,62.41,0,0,1,.62-6.38,59.82,59.82,0,0,1,1.28-6.28,11,11,0,0,1,.83-2.53,16.3,16.3,0,0,1-.47,2.61c-.33,1.6-.75,3.82-1.12,6.28s-.61,4.7-.77,6.33A14.7,14.7,0,0,1,223,257.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.26,240.38c-.21-.09-.43.12-.57.31a18,18,0,0,0-3.09,5.1c-1.11,3.32.07,7,1.08,10.4a27.67,27.67,0,0,1,1,10l-.25,1.17a10.13,10.13,0,0,0,.86-6.83,68.18,68.18,0,0,1-1.22-6.92c-.23-4.29,1.5-8.41,2.36-12.61C225.48,240.8,225.49,240.47,225.26,240.38Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 149.12,
    y: 334.34,
    width: 6.37,
    height: 45.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.05,304.56h0A6,6,0,0,0,65.21,308a89.37,89.37,0,0,1,45.68-.47c21.07,5.23,28.76,16.58,31.62,23.72a9.27,9.27,0,0,0,8.63,5.75H152a6,6,0,0,0,5.83-7.23c-2.18-9.9-15.35-27.1-38.89-33.46-28.33-7.66-48-2.56-57.15.29A6,6,0,0,0,58.05,304.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.05,304.56s-.09-.19-.23-.58a6,6,0,0,1,.45-4.66,6,6,0,0,1,3-2.67,90.43,90.43,0,0,1,25.25-4.52,100.87,100.87,0,0,1,17.72.93c1.58.25,3.19.48,4.81.76l4.93,1,5,1.24c1.66.54,3.39,1,5.07,1.61s3.4,1.25,5.06,2.06c.83.4,1.69.74,2.51,1.19l2.48,1.33a63.12,63.12,0,0,1,9.45,6.58,55.74,55.74,0,0,1,8.23,8.63l.92,1.21.85,1.28c.27.42.57.84.83,1.28l.76,1.34a28.37,28.37,0,0,1,2.49,5.69c.13.51.28,1,.41,1.52a6.57,6.57,0,0,1,.11,1.6,6.21,6.21,0,0,1-6.36,5.84,10,10,0,0,1-5.86-1.51,9.46,9.46,0,0,1-3.77-4.61,30,30,0,0,0-2.66-5.09c-.49-.82-1.08-1.56-1.63-2.32s-1.16-1.48-1.81-2.15a39.79,39.79,0,0,0-8.42-6.94,54.9,54.9,0,0,0-9.35-4.57,73.77,73.77,0,0,0-9.45-2.76A90.73,90.73,0,0,0,91.34,305,87.25,87.25,0,0,0,66,307.87a8.74,8.74,0,0,1-2.12.42,6,6,0,0,1-4.45-1.7,5.47,5.47,0,0,1-1.33-2,6.8,6.8,0,0,0,1.41,1.95A6,6,0,0,0,62,307.92a6.39,6.39,0,0,0,1.84.19,9.29,9.29,0,0,0,2.08-.43,85.52,85.52,0,0,1,25.45-3,89.07,89.07,0,0,1,17.61,2.2,75,75,0,0,1,9.51,2.75,54.83,54.83,0,0,1,9.45,4.6,40.06,40.06,0,0,1,8.53,7c.66.67,1.22,1.44,1.84,2.17s1.15,1.53,1.65,2.36a29.53,29.53,0,0,1,2.71,5.17,9,9,0,0,0,3.58,4.37,9.54,9.54,0,0,0,5.58,1.43,5.69,5.69,0,0,0,5.84-5.36,6.07,6.07,0,0,0-.1-1.47c-.12-.49-.27-1-.4-1.47a28.1,28.1,0,0,0-2.44-5.59L154,321.5c-.26-.43-.55-.85-.83-1.27L152.3,319l-.91-1.2a55.61,55.61,0,0,0-8.15-8.55,62.61,62.61,0,0,0-9.37-6.53l-2.45-1.33c-.81-.45-1.67-.78-2.49-1.18-1.65-.81-3.35-1.41-5-2.05s-3.38-1.08-5-1.61l-5-1.25-4.91-1c-1.62-.29-3.22-.52-4.79-.78a102.24,102.24,0,0,0-17.65-1,91.84,91.84,0,0,0-25.18,4.34,5.72,5.72,0,0,0-2.93,2.56,5.84,5.84,0,0,0-.77,2.78A6.77,6.77,0,0,0,58.05,304.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,302.15a4.83,4.83,0,1,1-4.83-4.83A4.82,4.82,0,0,1,68.5,302.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355,269.85h22.78L376,282.38s-1.48,6.16-5,6.16h-9.87a10.57,10.57,0,0,1-4.8-6.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,269.85a2.77,2.77,0,0,1,.07.4c0,.28.09.65.16,1.11.13,1,.32,2.41.56,4.17s.52,3.94.84,6.39a10.24,10.24,0,0,0,4.71,6.47l-.09,0,7.89,0c.7,0,1.41,0,2.1,0a2.93,2.93,0,0,0,1.83-.78,8.94,8.94,0,0,0,2.29-3.62,15.87,15.87,0,0,0,.52-1.61v0c.61-4.43,1.19-8.64,1.72-12.53l.18.21-16.35-.09-4.71-.05-1.27,0-.45,0a1.69,1.69,0,0,1,.41,0l1.23,0,4.67-.05,16.47-.09h.2l0,.2c-.53,3.89-1.1,8.11-1.69,12.53h0a13.92,13.92,0,0,1-.53,1.66,9.43,9.43,0,0,1-2.41,3.78,3.27,3.27,0,0,1-2.06.86c-.72,0-1.42,0-2.12,0l-7.89,0h-.05l0,0a10.5,10.5,0,0,1-4.82-6.73c-.33-2.51-.55-4.7-.76-6.5s-.35-3.17-.45-4.17l-.12-1.09A2,2,0,0,1,355,269.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,276.31l.34-.08s.21,0,0,0,.06,0,.1,0a6.09,6.09,0,0,1,.74,0c-.24,0,0,0,.09,0l.39.1.32.1c.15.05,0,0-.06,0l.21.1a6.65,6.65,0,0,1,.63.39c.13.09,0,0-.05,0l.13.11a3.7,3.7,0,0,1,.28.28c.07.08.21.27.08.08.08.11.15.22.22.33s.11.21.16.31,0,0,0-.06a1.43,1.43,0,0,1,.08.22,2.85,2.85,0,0,1,.11.39c0,.05.07.38.05.22s0,.17,0,.22a2.8,2.8,0,0,1,0,.41c0,.08,0,.16,0,.24s0,.21,0,0a2,2,0,0,1-.05.22,1.89,1.89,0,0,1-.09.34c0,.09-.15.4,0,.16a5.44,5.44,0,0,1-.37.67l-.1.14s.14-.16,0-.05-.21.22-.32.33-.29.23-.17.15-.15.09-.19.11l-.3.17-.15.08c.17-.09.08,0,0,0s-.52.14-.78.21.07,0,.09,0l-.23,0h-.78l-.22,0-.44-.14s-.19-.08,0,0-.15-.08-.15-.08a1.37,1.37,0,0,0-1.39,2.37,5.89,5.89,0,0,0,7.71-2.1,6.11,6.11,0,0,0,.64-4.33,5.58,5.58,0,0,0-2.5-3.48,5.93,5.93,0,0,0-4.68-.71,1.37,1.37,0,0,0,.73,2.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,276.31a.86.86,0,0,1-.46.08,1.43,1.43,0,0,1-1.16-.7,1.45,1.45,0,0,1,.52-2,3.89,3.89,0,0,1,1.33-.34,6.09,6.09,0,0,1,1.53,0,6,6,0,0,1,3.13,1.48,5.6,5.6,0,0,1,1.84,3.51,6.15,6.15,0,0,1-1,4.27,5.84,5.84,0,0,1-4,2.4,6.39,6.39,0,0,1-2.14-.06,8.41,8.41,0,0,1-1-.3l-.48-.22a1.34,1.34,0,0,1-.46-.34,1.65,1.65,0,0,1,0-2.07,1.62,1.62,0,0,1,2-.32l-.26.16a.19.19,0,0,1,.16-.18c.1,0,.11,0,.1,0h0l0,0,.07,0h0l0,0,0,0c0-.11.14.28-.08.32h-.11l-.08,0h0l0-.05c-.1-.4.28-.29.17-.3.05,0,0,0,0,0h0l.06,0,.14.05a4.3,4.3,0,0,0,.57.14h0s0,0,.1.05.06,0,.05.17-.14.14-.15.14h-.09l-.08,0h-.07s0,0,0,0-.1-.05-.05-.22.13-.08.15-.09h.45a5.43,5.43,0,0,0,.57,0l0,.34-.06,0h-.09a.17.17,0,0,1-.12-.05.16.16,0,0,1,0-.19c0-.07,0-.05,0-.06l.08-.05h0l.16,0,.29-.08.3-.08.13,0h0l0,0c-.07-.07,0,.34.1.29h.07l-.06,0-.16-.3.39-.21.18-.11,0,0,0,0h0a.2.2,0,0,1,.11,0,.26.26,0,0,1,.09.05.18.18,0,0,1,0,.23l0,0-.06,0h0a.14.14,0,0,1-.1,0,.18.18,0,0,1-.13-.1c-.06-.09.06-.22,0-.19h0l0,0a2.14,2.14,0,0,0,.32-.28l.14-.15,0,0,0,0,0,0h0s.17,0,.21.11,0,.08,0,.1h0l0,0h0l-.06.07-.26-.19c.18-.25.31-.52.46-.77l.28.13,0,.05v0l0,0v0s0,0-.12,0a.15.15,0,0,1-.14-.16v0l0-.11a1.46,1.46,0,0,0,.07-.19c0-.13.07-.26.1-.39l0-.1v0h0s0,0,.06-.09a.14.14,0,0,1,.14,0l.06,0a.23.23,0,0,1,0,.12h0v.1h0v0c.1.11-.42.06-.28,0v-.09a.28.28,0,0,1,0-.09c0-.13,0-.26,0-.38a2.26,2.26,0,0,0,0-.37v-.11a.17.17,0,0,1,.07-.12.12.12,0,0,1,.14,0,.08.08,0,0,1,.05.05c0,.05,0,.05,0,.05h0v.06h0v0a.14.14,0,0,1,0,.06s0,0-.08.05a.14.14,0,0,1-.16-.07l-.05-.22a5.61,5.61,0,0,0-.19-.67l.24-.09,0,.05,0,0v0h0v0a.11.11,0,0,1-.1.13c-.1,0-.1,0-.11,0l0,0s0-.08-.07-.12l-.1-.21-.24-.37.2-.13,0,.05,0,0h0a.11.11,0,0,1,0,.11.12.12,0,0,1-.2,0h0l-.07-.09a1.14,1.14,0,0,0-.15-.16l-.29-.28.14-.16.06,0,0,0h0s0,0,0,0c-.24.33-.1.08-.15.15h0l-.13-.08-.25-.16a3,3,0,0,0-.46-.26l.08-.17.08,0h.06s.05.12,0,.14l-.05,0H378l-.16-.06-.3-.09-.28-.07-.13,0h0c.06,0-.12.07,0-.14h.11v.14l-.66,0h-.25s0,0,0-.06l0,0h.15s0,0,0,.05,0,0,0,0h-.08a2,2,0,0,1-.38.05,1.31,1.31,0,0,1,.37-.12l.05,0h0v0c0,.07,0,0,0,0h0l-.11,0h0v0s0,0,0,0,0,0,0,0h.91v.14h-.11s0,0,0,0c.12-.22-.07-.12,0-.14h.16l.3.06.31.09.16.05h0c-.06.24-.06.15-.07.16l-.1,0,.08-.17a3.77,3.77,0,0,1,.48.26l.26.15.14.08h0l-.05.08s0-.07,0,0,0,0,0,0,0,0,0,0l0,0-.07-.06.14-.16a3.92,3.92,0,0,1,.31.28c0,.06.11.1.17.17l.07.09h0s-.05,0-.07,0l0,0s0,0,0,0,0,0,0,0l0,0h0v0l0-.05.2-.13c.08.12.17.24.25.38l.11.21s.07.06,0,.11l-.07.06a.13.13,0,0,0-.08,0h-.05v0l0-.07.24-.09a5.33,5.33,0,0,1,.22.71l0,.09v.07h0s0,0-.08,0,0,0-.05,0,0,0,0,0a.09.09,0,0,0-.07,0l-.06,0h0v0h.08s.05,0,.05,0,.05,0,.06,0H380v.07c0,.12,0,.27,0,.4a1.79,1.79,0,0,1,0,.4.37.37,0,0,1,0,.11v0h0s-.05,0-.12,0l-.17,0h0v-.09h0s0,0,0,0l0,0s.1,0,.08,0c.22,0,.13,0,.15,0v0l0,.1c0,.13-.07.28-.11.42a1,1,0,0,1-.07.21l0,.09c-.39-.16-.25-.12-.26-.14l0-.05.28.13c-.16.27-.29.56-.48.83l-.26-.19.07-.08.06,0s.07,0,.09.07l0,.05s.06.08.05.06h0l0,0-.15.16a3.18,3.18,0,0,1-.33.3h0l0,0c-.07-.06-.07-.11-.09-.1s0,0,0-.05l-.05-.09h0l0,0h0s.05.06,0,.07,0,.09,0,.09,0-.05,0,0a.1.1,0,0,0,.06.1l0,0h0l0,0-.05,0-.19.12-.4.22-.16-.3.07,0h.12c.15,0,.18.37.1.29l-.05,0,0,0-.16.06-.3.08-.31.08-.15,0s0,.08-.06-.15c0,0,0-.2,0-.18h.14l0,.34a4.09,4.09,0,0,1-.61,0,1.63,1.63,0,0,1-.31,0h-.11s0,0,0,0,0-.17,0-.17,0-.1,0-.15h.11s0,0,0,0,0,.08,0,.09,0,0,0,.06,0,0,0,0,0,0,0,.07a.16.16,0,0,1,0,.09h0a6,6,0,0,1-.61-.15l-.15-.05-.09,0h0l0-.06a.69.69,0,0,0,0-.1c.13-.26.06-.14.08-.17h0l.06,0h0s0,0,0,0,0,.12-.05.14l-.08.14h0l0,0-.07,0,0,0h0a.2.2,0,0,0,.11,0,.19.19,0,0,0,.13-.1l0-.05s0,0-.14,0l-.12.17a1.26,1.26,0,0,0-1.51.24,1.28,1.28,0,0,0,0,1.57,2.38,2.38,0,0,0,.79.45,6.08,6.08,0,0,0,.95.27,5.83,5.83,0,0,0,2,.07,5.43,5.43,0,0,0,3.76-2.24,5.75,5.75,0,0,0,1-4,5.29,5.29,0,0,0-1.7-3.32,5.76,5.76,0,0,0-3-1.45,5.15,5.15,0,0,0-2.7.22,1.37,1.37,0,0,0-.63.84,1.18,1.18,0,0,0,.14.88,1.35,1.35,0,0,0,1,.7A2.69,2.69,0,0,0,376,276.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,265.42a5.33,5.33,0,0,0,.71-.82,3.65,3.65,0,0,0,.44-2.8,3.14,3.14,0,0,0-1.07-1.64c-.55-.48-1.25-.86-1.9-1.43a3.75,3.75,0,0,1-.82-1.05,2,2,0,0,1-.18-1.39,2.66,2.66,0,0,1,.74-1.25c.33-.35.7-.65,1-1a3,3,0,0,0,.78-1.09,2.12,2.12,0,0,0,0-1.27,5.58,5.58,0,0,0-1.32-2.16,6.77,6.77,0,0,1-1.35-2,4.27,4.27,0,0,1-.22-2.09,4.47,4.47,0,0,1,1.39-2.65,3.66,3.66,0,0,1,.67-.47l.26-.11a9.59,9.59,0,0,0-.85.67,4.46,4.46,0,0,0-1.25,2.59,4.1,4.1,0,0,0,.24,2,6.73,6.73,0,0,0,1.33,1.89,5.74,5.74,0,0,1,1.4,2.27,2.4,2.4,0,0,1,0,1.45,3.28,3.28,0,0,1-.85,1.22c-.68.68-1.49,1.24-1.69,2.08a2.33,2.33,0,0,0,.9,2.16c.6.54,1.3.93,1.87,1.44a3.57,3.57,0,0,1,.72.84,3.29,3.29,0,0,1,.39.94,3.62,3.62,0,0,1-.55,2.92A2.26,2.26,0,0,1,370.37,265.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,265.42a5.71,5.71,0,0,0,.7-.82,3.56,3.56,0,0,0,.44-2.8,3,3,0,0,0-1.07-1.64c-.55-.48-1.25-.86-1.89-1.43a3.58,3.58,0,0,1-.82-1.05,2,2,0,0,1-.19-1.39,2.84,2.84,0,0,1,.74-1.25c.34-.35.7-.65,1-1a3.11,3.11,0,0,0,.77-1.09,2,2,0,0,0,0-1.27,5.58,5.58,0,0,0-1.32-2.16,7,7,0,0,1-1.36-2,4.27,4.27,0,0,1-.22-2.09,4.42,4.42,0,0,1,1.4-2.65,3.09,3.09,0,0,1,.67-.47.86.86,0,0,1,.26-.11,9.59,9.59,0,0,0-.85.67,4.52,4.52,0,0,0-1.26,2.59,4,4,0,0,0,.25,2,6.73,6.73,0,0,0,1.33,1.89,5.86,5.86,0,0,1,1.4,2.27,2.4,2.4,0,0,1,0,1.45,3.4,3.4,0,0,1-.85,1.22c-.68.68-1.5,1.24-1.7,2.08a2.35,2.35,0,0,0,.9,2.16c.6.54,1.31.93,1.87,1.44a3.62,3.62,0,0,1,.73.84,4,4,0,0,1,.39.94,3.7,3.7,0,0,1-.55,2.92A2.35,2.35,0,0,1,366,265.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.55,
    y: 201.14,
    width: 2.88,
    height: 43.57,
    transform: "translate(-47.22 315.94) rotate(-39.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.81,
    y: 196.44,
    width: 2.88,
    height: 43.57,
    transform: "translate(-43.44 316.95) rotate(-39.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.96,
    y: 235.18,
    width: 2.88,
    height: 52.39,
    transform: "translate(203.17 -179.77) rotate(32.26)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.53,
    y: 236.49,
    width: 2.88,
    height: 51.37,
    transform: "translate(204.62 -183.16) rotate(32.26)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,234.44l-4.39,5.94a3.68,3.68,0,0,0,.43,4.87h0a3.7,3.7,0,0,0,4.19.61l5.91-3a3.69,3.69,0,0,0,2-2.64l.06-.36a3.68,3.68,0,0,0-1.35-3.54l-3-2.39A2.66,2.66,0,0,0,427.74,234.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,234.44s.05-.14.23-.34a2.54,2.54,0,0,1,1-.68,2.68,2.68,0,0,1,1.87,0,3.13,3.13,0,0,1,1,.59l1,.78,1.12.86a8.94,8.94,0,0,1,1.2,1,3.9,3.9,0,0,1,.95,3.32,4,4,0,0,1-2.13,3.15l-3.58,1.81-1.81.92a5,5,0,0,1-1.94.67,3.92,3.92,0,0,1-4.14-4.94,4.08,4.08,0,0,1,.74-1.42l.85-1.12,2.6-3.38a10.51,10.51,0,0,1,1-1.19,8.5,8.5,0,0,1-.84,1.31l-2.47,3.48a8.39,8.39,0,0,0-1.47,2.43,3.51,3.51,0,0,0,.61,3,3.47,3.47,0,0,0,3.06,1.32,4.54,4.54,0,0,0,1.76-.62l1.81-.92,3.57-1.81a3.83,3.83,0,0,0,1.1-5.73,9.61,9.61,0,0,0-1.13-1c-.38-.31-.74-.61-1.1-.89l-1-.81a3.12,3.12,0,0,0-.92-.58,2.68,2.68,0,0,0-1.72,0A3.87,3.87,0,0,0,427.74,234.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,288.74s3.42-7.26,16.85-7.24l6.18,0s12.07,2.6,13.52,7.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62,198.76l2.78,11a.66.66,0,0,0,1.15.26l8.29-8.49a.66.66,0,0,0-.4-1.08L392.36,198A.65.65,0,0,0,391.62,198.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62,198.76s-.07-.08-.06-.27a.71.71,0,0,1,.53-.62,1.52,1.52,0,0,1,.6,0l.67.13,1.64.33,4.35.91,2.62.56,1.41.3a1,1,0,0,1,.77.52.92.92,0,0,1-.12,1h0l-3.69,3.79-4.61,4.7,0,0a.91.91,0,0,1-1.54-.25c-.13-.49-.22-.88-.33-1.3-.2-.83-.39-1.63-.58-2.38-.35-1.48-.67-2.79-.94-3.92s-.42-1.89-.58-2.57a3.6,3.6,0,0,1-.15-.94,5.23,5.23,0,0,1,.31.9c.19.67.43,1.51.71,2.53s.66,2.43,1.05,3.9l.63,2.36.33,1.25a.42.42,0,0,0,.71.11h0l4.59-4.72,3.7-3.78v0a.43.43,0,0,0-.36-.7l-1.4-.32-2.62-.6-4.33-1-1.63-.4-.66-.16a1.18,1.18,0,0,0-.52-.08.62.62,0,0,0-.48.46C391.61,198.66,391.64,198.76,391.62,198.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.42,230.12c5.49-7.35,8.6-14.83,8.08-22.48l-10.31-9.93c-10-3.33-23.75,7.16-23.75,7.16S360.85,223.37,383.42,230.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.77,187.74h.44a7.52,7.52,0,0,1,7.52,7.52v13.61a0,0,0,0,1,0,0H382.25a0,0,0,0,1,0,0V195.25A7.51,7.51,0,0,1,389.77,187.74Z",
    transform: "translate(241.19 -213.13) rotate(43.16)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,207.29a5.63,5.63,0,0,1-2.18-.36,12.61,12.61,0,0,1-4.63-2.61,12.76,12.76,0,0,1-3.18-4.28,5.71,5.71,0,0,1-.62-2.11,21.19,21.19,0,0,1,1,1.95,14.3,14.3,0,0,0,3.18,4.05,14.69,14.69,0,0,0,4.41,2.66C390,207.05,390.81,207.2,390.8,207.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.31,238a.93.93,0,1,1-.93-.93A.93.93,0,0,1,431.31,238Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.87,205.8a.93.93,0,1,1-.93-.93A.93.93,0,0,1,396.87,205.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.4,202.19a.93.93,0,1,1-.93-.93A.93.93,0,0,1,400.4,202.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.54,241.38a.93.93,0,1,1-.93-.93A.93.93,0,0,1,427.54,241.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.67 304.96 390.39 466.31 239.91 466.31 239.91 304.52 230.26 304.52 230.26 466.31 230.26 475.28 239.91 475.28 390.39 475.28 400.04 475.28 400.04 466.31 400.32 304.96 390.67 304.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,305l9.65,0h.05v0c0,21.51-.07,83.1-.13,170.32v.2H400l-169.78,0H230v-.25c0-47.28,0-98.73,0-152.12v-18.9h10.17v.26c0,57.08,0,111.57,0,161.79l-.24-.24,150.48.05-.19.19c.29-99.56.47-159.84.47-161.35,0,1.51,0,61.79-.08,161.35v.19h-.2l-150.48.05h-.24v-.24c0-50.22,0-104.71,0-161.79l.26.26h-9.65l.26-.26v18.64c0,53.39,0,104.84,0,152.12l-.25-.25,169.78.05-.2.2c.22-87.22.37-148.81.43-170.32l.05.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.34,
    y: 288.74,
    width: 218.04,
    height: 17.4,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,288.42l-.56.13c-.36.07-.9.15-1.59.31-1.38.28-3.36.76-5.77,1.47s-5.26,1.67-8.4,2.79-6.58,2.38-10.27,3.51a62.46,62.46,0,0,1-10.61,2.3A37.1,37.1,0,0,1,220,299a26.77,26.77,0,0,1-5.83-1.33,16.21,16.21,0,0,1-1.51-.6c-.34-.14-.51-.23-.51-.23s.19.05.54.18.85.35,1.52.54a28.51,28.51,0,0,0,5.82,1.22,38.54,38.54,0,0,0,8.8-.12,64.41,64.41,0,0,0,10.55-2.32c3.68-1.13,7.12-2.38,10.27-3.48s6-2.05,8.42-2.73a59.12,59.12,0,0,1,5.82-1.38c.69-.14,1.24-.2,1.6-.26S266,288.42,266,288.42Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21,304.49a2.25,2.25,0,0,1-.22-.24,9,9,0,0,0-.63-.7,12.36,12.36,0,0,0-2.89-2.2,16.36,16.36,0,0,0-5.43-1.82,23.35,23.35,0,0,0-7.59.19,78.41,78.41,0,0,0-9,2.31,48.35,48.35,0,0,1-10.43,2.2,20.92,20.92,0,0,1-5.77-.39,28.3,28.3,0,0,1-5.72-1.92c-3.75-1.65-7.37-3.89-11.37-5.51-8.05-3.24-16.56-3.49-23.95-2.54A84.26,84.26,0,0,0,275,299c-5.3,2-9.47,4-12.36,5.26l-3.33,1.51c-.76.35-1.17.52-1.17.52s.39-.21,1.14-.57l3.3-1.57c2.88-1.34,7.05-3.29,12.34-5.35a83,83,0,0,1,19.24-5.19c7.42-1,16-.73,24.1,2.53,4,1.64,7.65,3.88,11.37,5.52a28.17,28.17,0,0,0,5.66,1.91,20.33,20.33,0,0,0,5.69.39,49.16,49.16,0,0,0,10.38-2.15,77.84,77.84,0,0,1,9-2.28,23.41,23.41,0,0,1,7.66-.15,16.5,16.5,0,0,1,5.46,1.88,12.19,12.19,0,0,1,2.87,2.26A8.52,8.52,0,0,1,377.21,304.49Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.11,294.12a48.28,48.28,0,0,1-7.09,2.16c-1.12.26-2.35.53-3.68.72s-2.77.39-4.28.56a60.67,60.67,0,0,1-19.61-1.44c-1.47-.38-2.87-.72-4.14-1.16s-2.47-.84-3.54-1.25a47.43,47.43,0,0,1-6.7-3.18,2.82,2.82,0,0,1,.47.21l1.33.63c.57.29,1.28.63,2.12,1s1.78.79,2.86,1.16,2.24.83,3.53,1.21,2.68.76,4.14,1.13A62,62,0,0,0,413,297.27c1.5-.16,2.93-.28,4.26-.52s2.55-.44,3.67-.68,2.12-.51,3-.74,1.63-.44,2.23-.64l1.41-.44A2.84,2.84,0,0,1,428.11,294.12Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.07,
    y: 284.36,
    width: 71.43,
    height: 4.65,
    rx: 2.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.28,227,305.56,287.1a2.45,2.45,0,0,1-3,1.7h0a2.45,2.45,0,0,1-1.7-3l16.73-60.15a2.44,2.44,0,0,1,3-1.7h0A2.45,2.45,0,0,1,322.28,227Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.67,231.65c-.1.11-4.78-4.27-10.45-9.76s-10.18-10-10.08-10.14,4.77,4.26,10.44,9.76S308.77,231.55,308.67,231.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,238.84a11.29,11.29,0,0,1-1.67-.63l-4.45-1.87c-3.77-1.58-9-3.73-14.77-6s-11.09-4.23-14.92-5.63L266,223a10.93,10.93,0,0,1-1.64-.66,10,10,0,0,1,1.71.47c1.09.34,2.66.85,4.59,1.51,3.87,1.31,9.18,3.22,15,5.5s11,4.49,14.72,6.15c1.87.84,3.37,1.53,4.4,2A13.15,13.15,0,0,1,306.39,238.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.47,246a15.77,15.77,0,0,1-4.12.09,16.44,16.44,0,0,1-4.1-.43,32.65,32.65,0,0,1,8.22.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.22,446.84s-4.15-28.59-3.81-45.22,0-35.35,0-35.35h1.92s-1.3,33,.11,52.93,5.13,27.64,5.13,27.64h-3.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.61,334.1a5.05,5.05,0,0,0-1.74-2.55c-1.22-.77-2.81-.45-4.17,0-5.79,2.05-10.92,12.84-13.26,18.52l7.68,25.9C442,363.13,444.4,346.24,439.61,334.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,332.6a1.4,1.4,0,0,1-.12.33c-.09.25-.22.57-.37.95-.34.81-.81,2-1.38,3.47-1.13,2.94-2.57,7-3.86,11.68s-2.17,8.91-2.71,12c-.28,1.55-.48,2.81-.61,3.68-.07.41-.12.74-.17,1a1.49,1.49,0,0,1-.08.34,1.84,1.84,0,0,1,0-.35c0-.27.06-.6.1-1,.1-.88.27-2.15.52-3.71A110.3,110.3,0,0,1,431.39,349a109,109,0,0,1,4-11.68c.59-1.47,1.09-2.64,1.47-3.44.17-.37.31-.68.43-.92A1.17,1.17,0,0,1,437.42,332.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.71,382.21a23.45,23.45,0,0,1-11.85-19.7c-.28-5.74,1.49-11.38,3.49-16.78a2.15,2.15,0,0,1,.81-1.21,2.07,2.07,0,0,1,2,.3c5.23,3,8.41,8.67,10.09,14.45a29,29,0,0,1,1.19,11.88,19.77,19.77,0,0,1-5.7,11.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.71,382.21a1.6,1.6,0,0,1,0-.35l0-1c0-.87,0-2.12-.11-3.66a99.19,99.19,0,0,0-1.34-12c-.79-4.64-1.76-8.79-2.48-11.79l-.85-3.56-.22-1a1.45,1.45,0,0,1-.06-.34,1.4,1.4,0,0,1,.12.32c.07.26.16.57.28,1,.23.83.56,2,.95,3.53.77,3,1.78,7.15,2.58,11.8a89.9,89.9,0,0,1,1.25,12c0,1.54,0,2.79,0,3.66,0,.4,0,.73,0,1A1.6,1.6,0,0,1,424.71,382.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M424.71,382.21a23.45,23.45,0,0,1-11.85-19.7c-.28-5.74,1.49-11.38,3.49-16.78a2.15,2.15,0,0,1,.81-1.21,2.07,2.07,0,0,1,2,.3c5.23,3,8.41,8.67,10.09,14.45a29,29,0,0,1,1.19,11.88,19.77,19.77,0,0,1-5.7,11.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.84,426c7.09,1.56,12.92,6.56,19.77,9,4.52,1.61,9.64,2.18,13.25,5.34-.86-2.19-2.92-3.65-4.92-4.89A88,88,0,0,0,443,426.83c-3.21-1.11-6.71-2-10-1.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.58,432.27c-8.88-.15-18.23-7.71-27.06-8.16,9.24-3,22.49-.55,27.06,8.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,411a28.93,28.93,0,0,1,14.2-1,85.81,85.81,0,0,1,13.86,3.76c-.46-3.08-2.95-5.39-5.3-7.44a36.41,36.41,0,0,0-5.56-4.28,12.39,12.39,0,0,0-6.67-1.88,10.49,10.49,0,0,0-7.37,3.71,12.25,12.25,0,0,0-3.16,7.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.83,401.16c-5.59-4.77-14.06-4.31-21.41-4.14a173.85,173.85,0,0,1,33.2,20.69C419.92,412.51,414.89,407.19,407.83,401.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M407.83,401.16c-5.59-4.77-14.06-4.31-21.41-4.14a173.85,173.85,0,0,1,33.2,20.69C419.92,412.51,414.89,407.19,407.83,401.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M428.57,394.57a63,63,0,0,1,8.59-5c2.95-1.33,5.69-3.46,8.53-5,3.69-2,6.88-4.77,10.26-7.24s7.1-4.71,11.24-5.36a22,22,0,0,0-10.23.59,65.79,65.79,0,0,0-9.62,3.74c-4.36,2-8.8,4-12.36,7.17s-6.79,6.33-6.41,11.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44,432.27l-.28-.13-.77-.4c-.67-.35-1.63-.88-2.84-1.49-.6-.31-1.26-.64-2-1s-1.49-.7-2.31-1.06a33.35,33.35,0,0,0-5.47-1.9,11.74,11.74,0,0,0-5.69-.15,16.85,16.85,0,0,0-2.42.72,12.1,12.1,0,0,0-1.94,1,12.26,12.26,0,0,0-2.45,2c-.52.55-.77.88-.79.87a1,1,0,0,1,.16-.26,6.78,6.78,0,0,1,.54-.7,11.78,11.78,0,0,1,2.41-2.13,12.5,12.5,0,0,1,2-1.05,16.75,16.75,0,0,1,2.45-.76,11.84,11.84,0,0,1,5.84.12,32,32,0,0,1,5.51,1.94c.82.37,1.59.73,2.3,1.09s1.38.69,2,1c1.2.64,2.15,1.2,2.8,1.59l.74.45C452.36,432.2,452.45,432.26,452.44,432.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,427.86a2,2,0,0,1,.56.17,11.77,11.77,0,0,1,1.44.63,17.45,17.45,0,0,1,4.25,3,17.24,17.24,0,0,1,3.17,4.11,13.2,13.2,0,0,1,.69,1.42,2,2,0,0,1,.18.55c-.05,0-.38-.73-1.06-1.85a19.58,19.58,0,0,0-7.33-7C416.7,428.22,415.94,427.92,416,427.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.31,400.71a1.82,1.82,0,0,1,.38.11l1.07.38,1.68.62c.65.25,1.36.61,2.17,1a51.3,51.3,0,0,1,11.56,7.37,54.38,54.38,0,0,1,5.39,5.31,58.71,58.71,0,0,1,3.83,4.84c1,1.44,1.78,2.64,2.31,3.46l.6,1a1.45,1.45,0,0,1,.2.34,1.86,1.86,0,0,1-.25-.31c-.15-.2-.38-.51-.66-.92-.56-.81-1.35-2-2.39-3.4s-2.33-3-3.86-4.78a57.47,57.47,0,0,0-5.38-5.26A54.19,54.19,0,0,0,401.51,403c-.79-.36-1.49-.73-2.14-1l-1.66-.67-1-.44A1.93,1.93,0,0,1,396.31,400.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.38,406a3,3,0,0,1-.71-.09l-.82-.15c-.31-.06-.68-.06-1.09-.1a11.11,11.11,0,0,0-6.1,1.2,11.29,11.29,0,0,0-2.78,2.06,13.05,13.05,0,0,0-1.78,2.21,17.51,17.51,0,0,0-1.22,2.33,2.27,2.27,0,0,1,.18-.69,9.29,9.29,0,0,1,.85-1.76,11.25,11.25,0,0,1,1.77-2.29,10.59,10.59,0,0,1,2.83-2.14,10.86,10.86,0,0,1,6.27-1.15c.41.06.79.08,1.1.16l.82.2A3.83,3.83,0,0,1,439.38,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.3,378.28a1.28,1.28,0,0,1-.33.21l-1,.54c-.87.46-2.11,1.15-3.61,2s-3.27,2-5.15,3.34a43.05,43.05,0,0,0-5.74,4.82,14.26,14.26,0,0,0-2.35,3c-.58,1.11-1.14,2.19-1.65,3.23a58.85,58.85,0,0,0-2.46,5.62,34.62,34.62,0,0,0-1.21,3.95,15,15,0,0,1-.34,1.48,2.89,2.89,0,0,1,0-.39q0-.39.18-1.11a31.11,31.11,0,0,1,1.11-4,53.49,53.49,0,0,1,2.42-5.67c.51-1,1.06-2.13,1.64-3.25a14.66,14.66,0,0,1,2.39-3.11,41.33,41.33,0,0,1,5.8-4.83c1.9-1.34,3.69-2.43,5.21-3.31s2.78-1.52,3.66-1.95l1-.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.4,405.17a3.55,3.55,0,0,1-.17-.75c-.11-.54-.24-1.23-.39-2.05a52.4,52.4,0,0,0-4.22-13.05l-.86-1.9a3.18,3.18,0,0,1-.29-.72,3.86,3.86,0,0,1,.4.66c.23.44.56,1.07,1,1.86a47.72,47.72,0,0,1,2.63,6.39,46,46,0,0,1,1.6,6.72c.14.88.24,1.58.29,2.08A3.93,3.93,0,0,1,423.4,405.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76,385a24.06,24.06,0,0,0-2.89-9.59,31.62,31.62,0,0,0-21.45-16L418.28,389l2.57,5.29A15.28,15.28,0,0,0,422.76,385Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.23,
    y: 436.56,
    width: 55.93,
    height: 9.91,
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.41 444.5 411.91 475.26 446.3 475.26 451.98 444.5 404.41 444.5",
    style: {
      fill: "#325EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.13,446.48c0,.11-12.62.2-28.17.2s-28.18-.09-28.18-.2,12.61-.2,28.18-.2S456.13,446.37,456.13,446.48Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404Error.612c575b1a79b8dfb1fa95491047d2de.svg";
export { ForwardRef as ReactComponent };